import { StaticImage } from "gatsby-plugin-image"
import { FaCheck } from "react-icons/fa6"

export const GDPRSection = () => {
  return (
    <div className="my-10 md:my-[100px] relative z-10">
      <div className="container mx-auto">
        <div className="relative overflow-hidden rounded-[30px] md:rounded-[40px] px-10 md:px-16 py-10 md:py-16 bg-gradient-to-r from-[#6D4CFF] via-[#7A63E6] to-[#6DA1E2] flex items-center flex-col md:flex-row justify-between">
          <div className="max-w-xl !text-white">
            <h3 className="text-[26px] md:text-4xl font-semibold mb-6">
              GDPR-Compliant
            </h3>

            <p className="max-w-xl text-sm md:text-lg text-white leading-relaxed">
              Premagic follows GDPR principles across all data collection,
              processing, and storage. Attendee data is handled transparently
              and with explicit consent to meet global privacy standards.
            </p>
          </div>

          <div className="relative flex items-center justify-center right-0 md:right-20 mt-10 md:mt-0">
            {/* ripple effect */}
            <div className="absolute w-[420px] h-[420px] rounded-full border border-t-0 border-b-0 border-white/20 animate-ripple"></div>
            <div className="absolute w-[300px] h-[300px] rounded-full border border-t-0 border-b-0 border-white/20 animate-ripple"></div>
            <div className="absolute w-[180px] h-[180px] rounded-full border border-t-0 border-b-0 border-white/20 animate-ripple"></div>

            <StaticImage
              src="../../images/GDPR.png"
              alt="GDPR"
              className="w-[200px] md:w-[280px]"
              loading="lazy"
              placeholder="blurred"
            />
          </div>
        </div>
      </div>
    </div>
  )
}
